import {ASSETS_FOLDER} from "./index";


export const JS_FILES = {
    tagsInput: `${ASSETS_FOLDER}/vendor/bootstrap-tagsinput/js/bootstrap-tagsinput.min.js`,
    select: `${ASSETS_FOLDER}/vendor/bootstrap-select/dist/js/bootstrap-select.min.js`,
    hs: {
        core: `${ASSETS_FOLDER}/js/hs.core.js`,
        unfold: `${ASSETS_FOLDER}/js/components/hs.unfold.js`,
        modalWindow: `${ASSETS_FOLDER}/js/components/hs.modal-window.js`,
        selectPicker: `${ASSETS_FOLDER}/js/components/hs.selectpicker.js`,
        pluginsInit: {
            unfold: `${ASSETS_FOLDER}/js/components/initPlugins/unfold.js`,
            modalWindow: `${ASSETS_FOLDER}/js/components/initPlugins/modal-window.js`,
            selectPicker: `${ASSETS_FOLDER}/js/components/initPlugins/select-picker.js`,
        },
        goto: {
            script: `${ASSETS_FOLDER}/js/components/hs.go-to.js`,
            pluginInit: `${ASSETS_FOLDER}/js/components/initPlugins/go-to.js`
        },
        sticky: {
            script: `${ASSETS_FOLDER}/js/components/hs.sticky-block.js`,
            pluginInit: `${ASSETS_FOLDER}/js/components/initPlugins/sticky-block.js`
        }
    },
};
